"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.saveTicketStageProperties = saveTicketStageProperties;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var URI = 'sales/v1/property-requirements/TICKET/DEALSTAGE';

function fetch() {
  return (0, _ImmutableAPI.get)(URI + "/all");
}

function saveTicketStageProperties(_ref) {
  var stageId = _ref.stageId,
      properties = _ref.properties;
  return (0, _ImmutableAPI.put)(URI + "?actionId=" + encodeURIComponent(stageId), properties);
}